var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartingImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    rx: 57,
    fill: "#22CFE7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13V101.574H87.6672V24.8359L76.1268 13H25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3639 22.2969H29.8491V27.9219H81.3639V22.2969Z",
    fill: "#22CFE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0688 13.0195V24.8555H87.6092L76.0688 13.0195Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.869 41.2617H29.8491V43.7031H63.869V41.2617Z",
    fill: "#22CFE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3639 37.3555H71.1618V47.6289H81.3639V37.3555Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.869 56.6719H29.8491V59.1133H63.869V56.6719Z",
    fill: "#22CFE7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3639 52.7656H71.1618V63.0391H81.3639V52.7656Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.869 70.0117H29.8491V72.4531H63.869V70.0117Z",
    fill: "#22CFE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.869 74.1719H29.8491V76.6133H63.869V74.1719Z",
    fill: "#22CFE7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3639 68.1758H71.1618V78.4492H81.3639V68.1758Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.869 87.5117H29.8491V89.9531H63.869V87.5117Z",
    fill: "#22CFE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3639 83.5859H71.1618V93.8594H81.3639V83.5859Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7194 46.0664L71.8984 42.4336L72.8488 41.4375L75.5836 44.0352L79.3657 39.4258L80.4325 40.3047L75.7194 46.0664Z",
    fill: "#333D47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7194 61.2422L71.8984 57.6094L72.8488 56.5938L75.5836 59.2109L79.3657 54.582L80.4325 55.4609L75.7194 61.2422Z",
    fill: "#333D47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.497 46.9913L80.1345 68.5031L79.1501 67.5118L100.525 46L101.497 46.9913Z",
    fill: "#F97858"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.478 47.9813L81.1165 69.4922L82.0997 70.4823L103.461 48.9714L102.478 47.9813Z",
    fill: "#F97858"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.501 46.9832L80.139 68.4941L81.1223 69.4843L102.484 47.9733L101.501 46.9832Z",
    fill: "#FF916E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1035 70.4733L79.1502 67.5117L76 73.7695L82.1035 70.4733Z",
    fill: "#FFDB7A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76 73.7707L77.2429 71.2676L78.4611 72.4943L76 73.7707Z",
    fill: "#353F49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartingImage);
export default __webpack_public_path__ + "static/media/starting_image.fb52d90d1331f96f8aebaa73ace7f6e0.svg";
export { ForwardRef as ReactComponent };